import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/reset.css";
// import "./ant-override.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Context/authContext";
import backgroundVideo from "./images/leaks_detection_background_video.mp4";
import packageInfo from "../package.json";

console.log("leaks-detection-space package.json version:", packageInfo.version);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <div className="background-video-container">
      <video autoPlay muted loop className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
